module.exports = __webpack_public_path__ + "static/media/game.b80c5a53.jpg";